import { render, staticRenderFns } from "./samples.vue?vue&type=template&id=12c87858"
import script from "./samples.ts?vue&type=script&lang=js&external"
export * from "./samples.ts?vue&type=script&lang=js&external"
import style0 from "./samples.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports